import { dataModel } from "./architecture";
import { MermaidDiagram } from "@/components/diagrams/MermaidDiagram";

function buildErDiagram() {
  // Build a mermaid ER diagram from the data model.
  const lines = ["erDiagram"];
  for (const e of dataModel) {
    lines.push(`  ${e.name} {`);
    for (const f of e.fields) {
      lines.push(`    ${f.type.replace(/\s+/g, "_")} ${f.name}`);
    }
    lines.push("  }");
  }
  for (const e of dataModel) {
    for (const rel of e.relationships) {
      const target = dataModel.find((d) => d.id === rel.to);
      if (!target) continue;
      const sym = rel.kind === "1:N" ? "||--o{" : rel.kind === "N:1" ? "}o--||" : "||--||";
      lines.push(`  ${e.name} ${sym} ${target.name} : "${rel.kind}"`);
    }
  }
  return lines.join("\n");
}

export function AboutDataModel() {
  const src = buildErDiagram();
  return (
    <div style={{ display: "grid", gap: 20 }}>
      <MermaidDiagram source={src} title="Entity relationship diagram" caption="Generated from the data model definition." />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 12 }}>
        {dataModel.map((e) => (
          <div key={e.id} className="card" style={{ padding: 18 }}>
            <div className="lex-eyebrow">ENTITY</div>
            <div style={{ font: "var(--t-headline-sm)", fontStyle: "italic" }}>{e.name}</div>
            <p style={{ font: "var(--t-body-md)", color: "var(--md-on-surface-var)" }}>{e.description}</p>
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 8 }}>
              <thead>
                <tr>
                  <th style={th}>Field</th>
                  <th style={th}>Type</th>
                </tr>
              </thead>
              <tbody>
                {e.fields.map((f) => (
                  <tr key={f.name} style={{ borderTop: "1px solid var(--md-outline-var)" }}>
                    <td style={{ ...td, font: "var(--t-mono-sm)" }}>{f.name}</td>
                    <td style={{ ...td, color: "var(--md-on-surface-var)" }}>{f.type}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {e.relationships.length > 0 && (
              <div style={{ marginTop: 10, display: "flex", flexWrap: "wrap", gap: 6 }}>
                {e.relationships.map((r, i) => (
                  <span key={i} className="lex-chip" data-size="sm">{r.kind} → {r.to}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const th = { textAlign: "left" as const, padding: "8px 10px", font: "var(--t-label-md)", color: "var(--md-on-surface-var)" };
const td = { padding: "8px 10px", font: "var(--t-body-md)" };

export default AboutDataModel;
